<template>
  <a-card title="版本说明">
    <!--    <a-tabs style="background-color: white;"  default-active-key="2" @change="callback">-->
    <!--      <a-tab-pane tab="版本信息" key="1">-->
    <!--        <VersionInfo :tabKey='tabKey'></VersionInfo>-->
    <!--      </a-tab-pane>-->
    <!--      <a-tab-pane tab="升级版本" key="2">-->
    <!--        <VersionUpgrade :tabKey='tabKey'></VersionUpgrade>-->
    <!--      </a-tab-pane>-->
    <!--    </a-tabs>-->
    <VersionUpgrade></VersionUpgrade>
  </a-card>
</template>
<script>
import VersionInfo from './components/VersionInfo'
import VersionUpgrade from './components/VersionUpgrade'

export default {
  name: 'VersionDescription',
  components: { VersionInfo, VersionUpgrade },
  data() {
    return {
      tabKey: 2
    }
  },
  mounted() {
  },
  methods: {
    callback(key) {
      console.log(key)
      this.tabKey = key
    }
  }

}
</script>
<style scoped>
</style>